import WorkAuthentication from "@/services/authentication_services/WorkAuthentication";

export default function checkAuthenticated (to, from, next) {

    if (WorkAuthentication.isAuthenticated()) {
        next();
        return
    }
    next(`/login?to=${to.fullPath}`);
}
